import { Link } from 'react-router-dom';
import { ShareButton } from './ShareButton';

interface HeaderTenant {
  slug: string;
  name: string;
  spotifyUrl?: string | null;
  applePodcastsUrl?: string | null;
  s3AnchorImagePath?: string | null;
}

interface HeaderProps {
  tenant: HeaderTenant;
}

export function Header({ tenant }: HeaderProps) {
  const imageUrl = tenant.s3AnchorImagePath
    ? `https://assets.kaster.media/${tenant.s3AnchorImagePath}`
    : null;

  return (
    <header className="bg-white shadow-sm dark:bg-gray-800 dark:shadow-gray-900/50">
      <div className="mx-auto max-w-4xl px-4 py-6">
        <Link
          to="/"
          className="mb-4 inline-flex items-center gap-1 text-sm text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
          All Podcasts
        </Link>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {imageUrl && (
              <img
                src={imageUrl}
                alt={tenant.name}
                className="h-16 w-16 rounded-lg object-cover"
              />
            )}
            <div>
              <h1 className="font-heading text-2xl font-bold text-gray-900 dark:text-gray-100">
                {tenant.name}
              </h1>
              <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                AI-powered daily updates
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 flex gap-3">
          <a
            href={`https://kaster.media/feeds/${tenant.slug}/rss.xml`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary text-sm"
          >
            RSS Feed
          </a>
          {tenant.spotifyUrl && (
            <a
              href={tenant.spotifyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary text-sm"
            >
              Spotify
            </a>
          )}
          {tenant.applePodcastsUrl && (
            <a
              href={tenant.applePodcastsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary text-sm"
            >
              Apple Podcasts
            </a>
          )}
          <ShareButton
            topicSlug={tenant.slug}
            topicName={tenant.name}
          />
        </div>
      </div>
    </header>
  );
}
